/*
Shared timestamp formatter for the Emails tab.

Two different shapes of "timestamp string" show up here, and this one helper
handles both:

  - Mongoose `timestamps` fields (e.g. EmailTemplate.updatedAt) arrive from
    GraphQL as a String of epoch milliseconds, so rendering them raw shows
    "1769444822944".
  - A template's `revisions[].savedAt` (ps-back/util/email/revisionHistory.js)
    is a plain String field storing `new Date().toISOString()`, e.g.
    "2026-01-26T12:34:56.789Z".

The all-digits test is what tells them apart, and it matters: parseInt on the
ISO string returns 2026, which as an epoch is 1970 - so blindly treating every
value as epoch millis would silently render a wrong date instead of a right
one - a confidently wrong date that passes casual visual QA. Anything
non-numeric goes to the Date constructor instead (which parses ISO strings
correctly), and an unparseable value shows as-is rather than "Invalid Date".

Originally lived only in EmailTemplateDetail.jsx (for updatedAt); pulled out
here so EmailRevisionHistory.jsx (for revisions[].savedAt) can share the same
treatment instead of a second copy drifting out of sync - which also doubled
the blast radius of a regression here, hence formatTimestamp.test.js.

CommonJS on purpose, same reasoning as cmsTabs.js: the colocated test
(formatTimestamp.test.js) runs under plain `node`, with no webpack/babel
toolchain (this package has no test framework); both call sites still import
it as `import formatTimestamp from '...'` - babel's CJS interop treats
`module.exports = fn` as the default export, same as cmsTabs.js's named
exports are consumed elsewhere.
*/
const formatTimestamp = (value) => {
  if (!value) return '—';
  const raw = String(value);
  const parsed = /^\d+$/.test(raw) ? new Date(Number(raw)) : new Date(raw);
  return Number.isNaN(parsed.getTime()) ? raw : parsed.toLocaleString();
};

module.exports = formatTimestamp;
